import { create } from 'zustand'

import type { IMyWorkspace } from '../types/workspace'

interface SetupWorkspaceModalState {
  workspace: IMyWorkspace | null
  workspaceID: string | null
}

interface SetupWorkspaceModalActions {
  handleSetWorkspaceID: (id: string | null) => void
  setWorkspace: (workspace: IMyWorkspace | null) => void
}

const useSetupWorkspaceModalStore = create<SetupWorkspaceModalState & SetupWorkspaceModalActions>()((set) => ({
  handleSetWorkspaceID: (id: string | null) => {
    set({ workspaceID: id })
  },
  setWorkspace: (workspace: IMyWorkspace | null) => {
    set({ workspace })
  },
  workspace: null,
  workspaceID: null
}))

/**
 * Hook to manage the setup workspace modal store
 */
export const useSetupWorkspaceModal = () => {
  return useSetupWorkspaceModalStore()
}
